import { createSlice } from "@reduxjs/toolkit";

const configSlice = createSlice({
    name: 'configSlice',
    initialState: {
        data: [],
        isLoading: false
    },
    reducers: {
        startLoading: (state) => { state.isLoading = true; },
        stopLoading: (state) => { state.isLoading = false; },
        getUpdateConfig: (state, action) => { state.data = action.payload; },
    }
});

const configActions = configSlice.actions;

export { configActions };
export default configSlice.reducer;